import React from "react"
import FeeBuilderGeneral from "./tabs/FeeBuilderGeneral"
import FeeBuilderRates from "./tabs/FeeBuilderRates"
import FeeBuilderProducts from "./tabs/FeeBuilderProducts"
// import FeeBuilderCancellationRules from "./tabs/FeeBuilderCancellationRules"
import FeeBuilderGuestTypes from "./tabs/FeeBuilderGuestTypes"
import FeeBuilderTaxes from "./tabs/FeeBuilderTaxes"
import FeeBuilderFees from "./tabs/FeeBuilderFees"
import FeeBuilderTasks from "./tabs/FeeBuilderTasks"

export default class FeeBuilderTabContent extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="tab-content">
        <FeeBuilderGeneral {...this.props} />
        <FeeBuilderRates {...this.props} />
        <FeeBuilderProducts {...this.props} />
        {/* <FeeBuilderCancellationRules {...this.props} /> */}
        <FeeBuilderGuestTypes {...this.props} />
        {!this.props.tax ? <FeeBuilderTaxes {...this.props} /> : null}
        {this.props.tax ? <FeeBuilderFees {...this.props} /> : null}
        {/* {!this.props.new_record ? <FeeBuilderTasks {...this.props} /> : null} */}
        {/* {!this.props.tax ? <FeeBuilderTaxTasks {...this.props}} */}
        {/* {this.props.updateFolioItems ? <FeeBuilderUpdateFolioItems {...this.props} /> : null} */}
      </div>
    );
  }

};
